import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
const EdModalSearchBar = (props) => {
    const navigate = useNavigate();
    const ref = React.useRef(null);
    const handleClose = () => props.setShow(false);
    React.useEffect(() => {
        const body = document.querySelector("body");
        body.style.overflow = props.show ? "hidden" : "auto";
        return () => {
            body.style.overflow = "auto";
        };
    }, [props.show]);
    React.useEffect(() => {
        if (!props.DisableOutsideClickClose) {
            let handleClickOutside = (event) => {
                if (ref.current &&
                    !ref.current.contains(event.target) &&
                    event.view.innerWidth - 17 >= event.clientX) {
                    props.setShow(false);
                }
            };
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [ref]);
    return (React.createElement(Modal, { show: props.show, onHide: handleClose, className: "generic-searchbar-modal-block" },
        React.createElement(Modal.Header, null, props.headContent),
        React.createElement(Modal.Body, { className: "commonscroll-new" }, props.modalBodyContent),
        props.showFooter && React.createElement(Modal.Footer, null, props.footerContent)));
};
export default EdModalSearchBar;
